import i18n from "@/plugins/i18n";

/**
 * Return a display string for a KC status.
 */
export function getKcStatusTooltip(status: string | null | undefined) {
  if (status == null) return null;
  const normalized = String(status).toLowerCase().trim();

  const mapping: Record<string, string> = {
    not_yet_seen: "lingo_v2.tooltips.kc_status.not_yet_seen",
    seen: "lingo_v2.tooltips.kc_status.seen",
    learning: "lingo_v2.tooltips.kc_status.learning",
    reinforcing: "lingo_v2.tooltips.kc_status.reinforcing",
    practicing: "lingo_v2.tooltips.kc_status.reinforcing",
    mastered_prior_learning: "lingo_v2.tooltips.kc_status.mastered_prior_learning",
    mastered_new_learning: "lingo_v2.tooltips.kc_status.mastered_new_learning",
    mastered: "lingo_v2.tooltips.kc_status.mastered_gap_filled",
  };

  const entry = mapping[normalized];
  if (!entry) return null;

  // Safely call translator if available, otherwise return the translation key
  const translator = (i18n as any)?.global?.t;
  if (typeof translator === "function") {
    try {
      return String(translator(entry));
    } catch {
      return entry;
    }
  }

  return entry;
}
export default getKcStatusTooltip;